module.exports = __webpack_public_path__ + "static/media/02C.c5796321.png";